import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficiaryDetailsChanges } from '../../models/beneficiary-details-changes';
import { BeneficiarySubmissionUtils } from '../../utils/beneficiary-submission-utils';
import { SubmissionDetailsFieldChange } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-change';
import { SubmissionDetailsFieldChangesComponent } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-changes.component';
import { SubmissionDetailsFieldChangeTypeEnum } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-change-type.enum';

@Component({
  selector: 'app-beneficiary-details-organization-changes',
  standalone: true,
  imports: [CommonModule, SubmissionDetailsFieldChangesComponent],
  templateUrl: './beneficiary-details-organization-changes.component.html',
  styleUrls: [
    '../../../../views/shared/components/member-beneficiary-submission-details/member-beneficiary-submission-details.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeneficiaryDetailsOrganizationChangesComponent implements OnChanges {
  // The organization name is shown as the card title, so it is intentionally excluded from the section fields.
  private static readonly organizationKeys = [
    'organizationPhoneNumber',
    'address.addressLine1',
    'address.addressLine2',
    'address.addressLine3',
    'address.city',
    'address.state',
    'address.country',
    'address.postalCode'
  ];
  private static readonly contactKeys = ['firstName', 'lastName', 'phoneNumber'];

  @Input() beneficiaryChanges!: BeneficiaryDetailsChanges;

  public organizationPrevious: SubmissionDetailsFieldChange[] = [];
  public organizationNew: SubmissionDetailsFieldChange[] = [];
  public organizationPreviousNotApplicable = false;
  public organizationNewNotApplicable = false;

  public contactPrevious: SubmissionDetailsFieldChange[] = [];
  public contactNew: SubmissionDetailsFieldChange[] = [];
  public contactPreviousNotApplicable = false;
  public contactNewNotApplicable = false;
  public contactSectionHidden = false;

  public ngOnChanges(): void {
    const { previous, new: newChanges } = this.beneficiaryChanges;

    const organizationPrevious = BeneficiarySubmissionUtils.toDetailsSection(
      previous,
      BeneficiaryDetailsOrganizationChangesComponent.organizationKeys
    );
    const organizationNew = BeneficiarySubmissionUtils.toDetailsSection(
      newChanges,
      BeneficiaryDetailsOrganizationChangesComponent.organizationKeys
    );
    this.organizationPrevious = organizationPrevious.items;
    this.organizationNew = organizationNew.items;
    this.organizationPreviousNotApplicable = organizationPrevious.notApplicable;
    this.organizationNewNotApplicable = organizationNew.notApplicable;

    const contactPrevious = BeneficiarySubmissionUtils.toDetailsSection(
      previous,
      BeneficiaryDetailsOrganizationChangesComponent.contactKeys
    );
    const contactNew = BeneficiarySubmissionUtils.toDetailsSection(
      newChanges,
      BeneficiaryDetailsOrganizationChangesComponent.contactKeys
    );
    this.contactPrevious = contactPrevious.items;
    this.contactNew = contactNew.items;
    this.contactPreviousNotApplicable = contactPrevious.notApplicable;
    this.contactNewNotApplicable = contactNew.notApplicable;
    this.contactSectionHidden = contactPrevious.notApplicable && contactNew.notApplicable;
  }

  protected readonly SubmissionDetailsFieldChangeTypeEnum = SubmissionDetailsFieldChangeTypeEnum;
}
